(() => {
  const formatMoney = (cents, currency = 'USD') => {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) return Shopify.formatMoney(cents);
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(cents / 100);
  };

  function init(root) {
    if (root.dataset.enhanced === 'true') return;
    root.dataset.enhanced = 'true';

    const minimum = Math.max(1, Number(root.dataset.minimumItems) || 1);
    const currency = root.dataset.currency || 'USD';
    const products = [...root.querySelectorAll('[data-box-product]')];
    const categoryButtons = [...root.querySelectorAll('[data-box-category]')];
    const selections = new Map();
    const summary = root.querySelector('[data-box-summary]');
    const summaryItems = root.querySelector('[data-box-summary-items]');
    const summaryEmpty = root.querySelector('[data-box-summary-empty]');
    const submit = root.querySelector('[data-box-submit]');
    const status = root.querySelector('[data-box-status]');
    const mobileToggle = root.querySelector('[data-box-summary-toggle]');
    const closeSummary = root.querySelector('[data-box-summary-close]');
    let activeCategory = 'all';

    function getVariantControl(form) {
      return form.querySelector('[data-box-variant]');
    }

    function getVariantData(form) {
      const control = getVariantControl(form);
      const source = control.tagName === 'SELECT' ? control.selectedOptions[0] : control;
      return {
        id: Number(control.value),
        title: source.dataset.productTitle,
        variantTitle: source.dataset.title === 'Default Title' ? '' : source.dataset.title,
        price: Number(source.dataset.price),
        priceFormatted: source.dataset.priceFormatted,
        image: source.dataset.image,
        url: source.dataset.productUrl,
        available: source.dataset.available === 'true'
      };
    }

    function setSummaryOpen(open) {
      summary.classList.toggle('is-open', open);
      mobileToggle.setAttribute('aria-expanded', String(open));
      root.querySelector('[data-box-mobile-action]').textContent = open ? 'Hide summary' : 'Review box';
      if (open) closeSummary.focus({ preventScroll: true });
      else mobileToggle.focus({ preventScroll: true });
    }

    function renderSummary() {
      const lines = [...selections.values()];
      const itemCount = lines.reduce((sum, line) => sum + line.quantity, 0);
      const subtotal = lines.reduce((sum, line) => sum + line.price * line.quantity, 0);
      const remaining = Math.max(0, minimum - itemCount);

      summaryItems.replaceChildren();
      lines.forEach((line) => {
        const item = document.createElement('li');
        item.className = 'me-box-summary__item';
        const media = line.image ? document.createElement('img') : document.createElement('span');
        if (line.image) {
          media.src = line.image;
          media.width = 46;
          media.height = 46;
          media.alt = '';
        }
        const copy = document.createElement('span');
        copy.className = 'me-box-summary__item-copy';
        const title = document.createElement('strong');
        title.textContent = line.title;
        const detail = document.createElement('small');
        detail.textContent = `${line.variantTitle || 'Standard option'} · ${line.priceFormatted}`;
        copy.append(title, detail);
        const controls = document.createElement('span');
        controls.className = 'me-box-summary__item-controls';
        const decrease = document.createElement('button');
        decrease.type = 'button';
        decrease.dataset.boxLineChange = '-1';
        decrease.dataset.variantId = line.id;
        decrease.setAttribute('aria-label', `Decrease ${line.title} quantity`);
        decrease.textContent = '−';
        const amount = document.createElement('span');
        amount.setAttribute('aria-label', `Quantity ${line.quantity}`);
        amount.textContent = line.quantity;
        const increase = document.createElement('button');
        increase.type = 'button';
        increase.dataset.boxLineChange = '1';
        increase.dataset.variantId = line.id;
        increase.setAttribute('aria-label', `Increase ${line.title} quantity`);
        increase.textContent = '+';
        controls.append(decrease, amount, increase);
        item.append(media, copy, controls);
        summaryItems.append(item);
      });

      summaryEmpty.hidden = lines.length > 0;
      root.querySelector('[data-box-count]').textContent = `${itemCount} ${itemCount === 1 ? 'item' : 'items'}`;
      root.querySelector('[data-box-subtotal]').textContent = formatMoney(subtotal, currency);
      root.querySelector('[data-box-mobile-count]').textContent = `${itemCount} ${itemCount === 1 ? 'item' : 'items'}`;
      root.querySelector('[data-box-mobile-total]').textContent = formatMoney(subtotal, currency);
      const minimumMessage = root.querySelector('[data-box-minimum]');
      minimumMessage.dataset.ready = String(remaining === 0);
      minimumMessage.textContent = remaining ? `Add ${remaining} more ${remaining === 1 ? 'item' : 'items'} to meet the ${minimum}-item box minimum.` : `Your box meets the ${minimum}-item minimum.`;
      submit.disabled = itemCount < minimum;
      submit.textContent = itemCount ? `Add ${itemCount} ${itemCount === 1 ? 'item' : 'items'} to cart` : 'Add box to cart';
    }

    function filterProducts(category) {
      activeCategory = category;
      let visible = 0;
      products.forEach((product) => {
        const matches = category === 'all' || product.dataset.boxCategories.split(/\s+/).includes(category);
        product.hidden = !matches;
        if (matches) visible += 1;
      });
      categoryButtons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.boxCategory === category)));
      root.querySelector('[data-box-results]').textContent = `${visible} ${visible === 1 ? 'cut' : 'cuts'} to choose from`;
      root.querySelector('[data-box-empty]').hidden = visible > 0;
    }

    categoryButtons.forEach((button) => {
      const category = button.dataset.boxCategory;
      const count = products.filter((product) => category === 'all' || product.dataset.boxCategories.split(/\s+/).includes(category)).length;
      button.querySelector('[data-box-category-count]').textContent = `(${count})`;
      button.hidden = count === 0;
      button.addEventListener('click', () => filterProducts(category));
    });

    root.querySelectorAll('[data-box-item-form]').forEach((form) => {
      const variantControl = getVariantControl(form);
      const quantity = form.querySelector('[data-box-quantity]');
      const add = form.querySelector('[data-box-add]');
      const cardStatus = form.querySelector('[data-box-item-status]');

      if (!add.disabled) add.textContent = 'Add to box';

      form.querySelectorAll('[data-box-quantity-change]').forEach((button) => button.addEventListener('click', () => {
        quantity.value = Math.max(1, (Number(quantity.value) || 1) + Number(button.dataset.boxQuantityChange));
      }));

      variantControl.addEventListener('change', () => {
        const variant = getVariantData(form);
        form.closest('[data-box-product]').querySelector('[data-box-item-price]').textContent = variant.priceFormatted;
        add.disabled = !variant.available;
        add.textContent = variant.available ? 'Add to box' : 'Sold out';
      });

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        if (!form.reportValidity()) return;
        const variant = getVariantData(form);
        const amount = Math.max(1, Number(quantity.value) || 1);
        if (!variant.available) return;
        const existing = selections.get(variant.id);
        selections.set(variant.id, { ...variant, quantity: amount + (existing?.quantity || 0) });
        quantity.value = 1;
        cardStatus.textContent = `${amount} added to your box.`;
        status.textContent = '';
        renderSummary();
      });
    });

    summaryItems.addEventListener('click', (event) => {
      const button = event.target.closest('[data-box-line-change]');
      if (!button) return;
      const id = Number(button.dataset.variantId);
      const line = selections.get(id);
      if (!line) return;
      line.quantity += Number(button.dataset.boxLineChange);
      if (line.quantity <= 0) selections.delete(id);
      renderSummary();
    });

    mobileToggle.addEventListener('click', () => setSummaryOpen(!summary.classList.contains('is-open')));
    closeSummary.addEventListener('click', () => setSummaryOpen(false));
    summary.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && summary.classList.contains('is-open')) setSummaryOpen(false);
    });
    root.querySelector('[data-box-continue]').addEventListener('click', () => {
      setSummaryOpen(false);
      root.querySelector('[data-box-category][aria-pressed="true"]')?.focus({ preventScroll: true });
      root.querySelector('[data-box-products]').scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    });
    root.querySelector('[data-box-show-all]').addEventListener('click', () => filterProducts('all'));

    submit.addEventListener('click', async () => {
      const items = [...selections.values()].map((line) => ({
        id: line.id,
        quantity: line.quantity,
        properties: { _Custom_box: 'Build Your Order' }
      }));
      const itemCount = items.reduce((sum, item) => sum + item.quantity, 0);
      if (itemCount < minimum) return;

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const body = { items };
      if (cart?.getSectionsToRender) {
        body.sections = cart.getSectionsToRender().map((section) => section.id);
        body.sections_url = window.location.pathname;
        cart.setActiveElement?.(submit);
      }

      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
      submit.textContent = 'Adding…';
      status.textContent = '';
      try {
        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body)
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || 'We could not add this box. Please try again.');
        selections.clear();
        renderSummary();
        const sectionsReady = cart?.getSectionsToRender && result.sections &&
          cart.getSectionsToRender().every((section) => result.sections[section.id]);
        if (cart?.renderContents && sectionsReady) {
          try {
            cart.classList.remove('is-empty');
            cart.renderContents(result);
          } catch (_error) {
            window.location.assign(window.routes?.cart_url || '/cart');
          }
        } else window.location.assign(window.routes?.cart_url || '/cart');
      } catch (error) {
        status.textContent = error.message || 'We could not add this box. Your selections are still here; please try again.';
        submit.disabled = false;
      } finally {
        submit.removeAttribute('aria-busy');
        if (selections.size) renderSummary();
      }
    });

    filterProducts(activeCategory);
    renderSummary();
  }

  document.querySelectorAll('[data-box-builder]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-box-builder]').forEach(init));
})();
